module.exports = __webpack_public_path__ + "static/media/ic_participants.778fbce3.svg";